import { Badge } from "@/components/ui/badge"
import { ORDER_STATUS_LABELS, SCENE_STATUS_LABELS } from "@/lib/domain"
import type { DownloadRecord, OrderStatus, SceneStatus } from "@/lib/domain"
import { cn } from "@/lib/utils"

const orderClasses: Record<OrderStatus, string> = {
  draft: "border-[#d6e0e3] bg-[#f2f5f5] text-[#51636d]",
  submitted: "border-[#b8dbe1] bg-[#eaf7f8] text-[#155466]",
  review: "border-[#efd798] bg-[#fff7df] text-[#644b0d]",
  approved: "border-[#b8dcc8] bg-[#eaf6ef] text-[#246947]",
  ready: "border-[#a7d3df] bg-[#e5f4f8] text-[#075c7f]",
  completed: "border-[#cdd8dc] bg-[#eef3f4] text-[#344b59]",
  rejected: "border-[#efc3c9] bg-[#fff0f2] text-[#8f2d3a]",
}

const sceneClasses: Record<SceneStatus, string> = {
  available: "border-[#b8dcc8] bg-[#eaf6ef] text-[#246947]",
  restricted: "border-[#efd798] bg-[#fff7df] text-[#644b0d]",
  processing: "border-[#b8dbe1] bg-[#eaf7f8] text-[#155466]",
}

const downloadClasses: Record<DownloadRecord["status"], string> = {
  available: "border-[#b8dcc8] bg-[#eaf6ef] text-[#246947]",
  preparing: "border-[#b8dbe1] bg-[#eaf7f8] text-[#155466]",
  expired: "border-[#d6e0e3] bg-[#f2f5f5] text-[#596a73]",
}

export function OrderStatusBadge({
  status,
  className,
}: {
  status: OrderStatus
  className?: string
}) {
  return (
    <Badge variant="outline" className={cn(orderClasses[status], className)}>
      <span className="size-1.5 rounded-full bg-current opacity-75" />
      {ORDER_STATUS_LABELS[status]}
    </Badge>
  )
}

export function SceneStatusBadge({
  status,
  className,
}: {
  status: SceneStatus
  className?: string
}) {
  return (
    <Badge variant="outline" className={cn(sceneClasses[status], className)}>
      <span className="size-1.5 rounded-full bg-current opacity-75" />
      {SCENE_STATUS_LABELS[status]}
    </Badge>
  )
}

export function DownloadStatusBadge({
  status,
}: {
  status: DownloadRecord["status"]
}) {
  return (
    <Badge variant="outline" className={downloadClasses[status]}>
      <span className="size-1.5 rounded-full bg-current opacity-75" />
      {status === "available"
        ? "Available"
        : status === "preparing"
          ? "Preparing"
          : "Expired"}
    </Badge>
  )
}
